import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Activity, Flame } from 'lucide-react';
export function AgitationSection() {
  const painPoints = [{
    icon: <Activity className="w-6 h-6 text-urgency" data-id="element-13" />,
    title: 'Cardio Extremo',
    desc: 'Has probado el cardio extremo y solo te dejó más agotada, sin mover la aguja de la báscula.'
  }, {
    icon: <Flame className="w-6 h-6 text-urgency" data-id="element-14" />,
    title: 'Dietas Restrictivas',
    desc: 'Has contado calorías hasta la obsesión y tu metabolismo simplemente se detuvo por completo.'
  }, {
    icon: <AlertTriangle className="w-6 h-6 text-urgency" data-id="element-15" />,
    title: 'La Trampa del Cortisol',
    desc: 'Después de los 40, comer menos y esforzarse más es la receta perfecta para el desastre hormonal.'
  }];
  return <section className="py-20 px-4 bg-cream-dark border-y border-sage/10" data-id="element-16">
      <div className="max-w-4xl mx-auto" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-18">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-dark mb-6" data-id="element-19">
            Lo que nadie te ha dicho sobre tu metabolismo
          </h2>
          <p className="text-lg text-dark-light" data-id="element-20">
            Estás atrapada en un ciclo de estrés metabólico que ninguna "dieta
            de moda" puede arreglar.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-21">
          {painPoints.map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-sage/10 text-center" data-id="element-22">
              <div className="w-12 h-12 bg-urgency/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-23">
                {point.icon}
              </div>
              <h3 className="font-heading font-bold text-xl text-dark mb-3" data-id="element-24">
                {point.title}
              </h3>
              <p className="text-dark-light text-sm leading-relaxed" data-id="element-25">
                {point.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-urgency/5 border border-urgency/20 p-8 rounded-2xl text-center" data-id="element-26">
          <p className="text-lg text-dark font-medium italic" data-id="element-27">
            "Cada vez que pasas hambre, tu cortisol se dispara, dándole a tu
            cuerpo una orden clara:{' '}
            <strong className="text-urgency font-bold" data-id="element-28">
              ¡Peligro! Almacena toda la grasa posible en el abdomen para
              sobrevivir
            </strong>
            ."
          </p>
        </motion.div>
      </div>
    </section>;
}